<template>
    <a
        class="download-button"
        :href="`./pdf/${pdf}`"
        :download="pdf"
    >
        Download ({{ size }})
    </a>
</template>

<script>
export default {
    name: 'DownloadButton',
    props: {
        pdf: {
            type: String,
            required: true
        },
        size: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="scss" src="./DownloadButton.scss" />
